import React from 'react';
import {Icon} from '@iconify/react';
import {useDispatch, useSelector} from 'react-redux';
import {t} from 'i18next';
import {scrollLeftAction, scrollRightAction} from '../../../../store/actions/presentation.actions';
import {useSlideSelectable} from '../../../../hooks/useSlideSelectable';
import {currentSlideIndexSelector} from '../../../../store/selectors/presentation.selectors';
import TooltipWrapper from '../../../../ui/components/common/TooltipWrapper';

interface SlideNavigationProps {
    children: React.ReactNode;
}

function SlideNavigation({children}: SlideNavigationProps): JSX.Element {
    const dispatch = useDispatch();
    const currentSlideIndex = useSelector(currentSlideIndexSelector);
    const {isSelectable, blockedTooltipKey} = useSlideSelectable(currentSlideIndex + 1);

    return (
        <>
            <button
                type="button"
                className="c-slideNavigation"
                onClick={() => dispatch(scrollLeftAction())}
                disabled={currentSlideIndex === 0}
            >
                <Icon icon="ph:caret-left" fontSize="2.5rem" />
            </button>
            {children}
            <button type="button" className="c-slideNavigation" onClick={() => dispatch(scrollRightAction())} disabled={!isSelectable}>
                <TooltipWrapper id="nextBtnDisabledTooltip" content={t(blockedTooltipKey)} disable={isSelectable} delayShow={300}>
                    <button type="button" disabled={!isSelectable}>
                        <Icon icon="ph:caret-right" fontSize="2.5rem" />
                    </button>
                </TooltipWrapper>
            </button>
        </>
    );
}

export default SlideNavigation;
